import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getDriversDHTLimits } from '../../services/DriversService';
import { DHTLimitsResponse } from '../../types/Drivers';

function useGetDHTLimitsPerDriver(fleetId: string, driver: string, enabled = true): UseQueryResult<DHTLimitsResponse> {
  return useQuery(
    ['drivers-dht', fleetId, driver],
    async (): Promise<DHTLimitsResponse> => getDriversDHTLimits(fleetId, driver),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: true,
      enabled: enabled && !!driver,
    },
  );
}

export default useGetDHTLimitsPerDriver;
